"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const PopupDialog_1 = tslib_1.__importDefault(require("../../dialogs/PopupDialog"));
/**
 * @deprecated use {@link PopupDialog.warning} instead
 */
class ErrorDisplay {
    static showError(title, message) {
        PopupDialog_1.default.warning(title, message);
    }
}
exports.default = ErrorDisplay;
//# sourceMappingURL=ErrorDisplay.js.map